import React from "react";
import InputField from "../../components/InputField";

const IndexAdjustmentForm = ({
  indexAdjustment,
  setIndexAdjustment,
  setHasChanges,
  disabled,

}) => {
/*   const selectedBillingGroup = indexAdjustment?.billingGroupName || "";
 */
  return (
    <>
      {/* Two-column layout */}
      <div className="grid grid-cols-2 gap-6 w-full">
        {/* Column 1 */}
        <div className="flex flex-col gap-4">

          <InputField
            label="Index adjustment ID"
            placeholder="Index adjustment ID"
            value={indexAdjustment?.indexAdjustmentPublicId || ""}
            onChange={(e) => {
              setIndexAdjustment((s) => ({ ...s, indexAdjustmentPublicId: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={disabled}
          />

          <InputField
            label="Index factor"
            placeholder="Index factor"
            type="number"
            value={indexAdjustment?.indexFactor || ""}
            onChange={(e) => {
              setIndexAdjustment((s) => ({ ...s, indexFactor: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={disabled}
          />

        </div>

        {/* Column 2 */}
        <div className="flex flex-col gap-4">

          <InputField
            label="Name"
            placeholder="Name"
            value={indexAdjustment?.name || ""}
            onChange={(e) => {
              setIndexAdjustment((s) => ({ ...s, name: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={disabled}
          />

        </div>
      </div>
    </>
  );
};

export default IndexAdjustmentForm;
